"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 500px;\n  height: 80px;\n  border: 1px solid ", ";\n  padding: 10px;\n  p {\n    font-family: ", ";\n    font-size: 12px;\n    line-height: 15px;\n    color: ", ";\n    text-decoration: ", ";\n  }\n"])), _variables.GlobalColors.s2, _variables.FontFamily.AvenirNext, _variables.GlobalColors.deep_gray, function (_ref) {
  var reviewed = _ref.reviewed;
  return reviewed ? "line-through" : "none";
});

exports.Container = Container;